// extracted by mini-css-extract-plugin
export default {"root":"bvtof","color-green":"BeB0k","inline":"HpNKB"};